export const getAllSelectedInstallationServices = (form) => {
    const mainServices = form.getAll('mainServices').map(String);
    const subServices = form.getAll('subServices').map(String);
    const individualMainServices = form.getAll('individualMainServices').map(String);
    return [...mainServices, ...subServices, ...individualMainServices];
};
export const getInstallationServiceAccessory = (form) => {
    return form.get('installationServiceAccessory');
};
//# sourceMappingURL=Helpers.js.map